import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Index from "@/zh-website/src/views/Index.vue";
import { searchRoute } from "@/zh-website/src/router/search";
import Teminations from "../views/Colleges/terminations.vue";
import Legal from "../views/Colleges/Legal.vue";
import PrivacyAgreement from "../views/partner/supplier/PrivacyAgreement.vue";
import PrivacyPersonalData from "../views/partner/supplier/PrivacyPersonalData.vue";
import Website from "../views/Colleges/Website.vue";
import AboutUs from "../views/Homes/AboutUs.vue";
import Commitment from "../views/Recruit/Commitment.vue";
import FillCommitment from "../views/Recruit/FillCommitment.vue";
import Homes from "../views/Homes/Home.vue";
import Feedback from "../views/Homes/Feedback.vue";
import NewsCenter from "../views/Content/NewsCenter.vue";
import NewsIndex from "../views/Content/NewsIndex.vue";
import NewsDetail from "../views/Content/NewsDetail.vue";
import ReportsCenter from "../views/Content/ReportsCenter.vue";
import PubBiddingCenter from "../views/partner/PubBiddingCenter.vue";
import PubBiddingIndex from "../views/partner/PubBiddingIndex.vue";
import PubBiddingDetail from "../views/partner/PubBiddingDetail.vue";
import PubBiddingApplySubmit from "@/zh-website/src/views/partner/PubBiddingApplySubmit.vue";
import PubBiddingFileDownload from "@/zh-website/src/views/partner/PubBiddingFileDownload.vue";
import Report from "../views/Content/Report.vue";
import NewArrival from "../views/Content/NewArrival.vue"
import SubjectAndNewsCenter from "../views/Content/SubjectAndNewsCenter.vue";
import SubjectAndPubBiddingCenter from "../views/partner/SubjectAndPubBiddingCenter.vue";
import { EnterpriseRoute } from "./enterprise";
import { CollegesRoute } from "./colleges";
import { PartnerRoute } from "@/zh-website/src/router/partner";
import { RecruitRoute } from "@/zh-website/src/router/recruit";
import CustomDetail from "@/zh-website/src/views/Enterprise/components/custom-publicity/custom-detail.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/recruit/commitment",
    name: "commitment",
    component: Commitment,
    meta: {
      type: 1,
      title: "面试承诺书-浙江华为门户网站",
      serial: 1
    }
  },
  {
    path: "/recruit/fillCommitment",
    name: "fillCommitment",
    component: FillCommitment,
    meta: {
      type: 1,
      title: "面试承诺书-浙江华为门户网站",
      serial: 1
    }
  },
  {
    path: "/",
    component: Index,
    redirect: "/home/page",
    children: [
      {
        path: "/home/page",
        name: "Index",
        component: Homes,
        meta: { type: 1, title: "主页-浙江华为门户网站" }
      },
      {
        path: "/custom-publicity/detail/:id",
        name: "custom-publicity",
        component: CustomDetail,
        meta: {
          type: 1,
          title: "详情-浙江华为门户网站",
          serial: 1
        }
      },
      {
        path: "/Colleges/terminations",
        name: "terminations",
        component: Teminations,
        meta: {
          type: 4,
          title: "除名查询-浙江华为门户网站",
          serial: 3
        }
      },
      {
        path: "/colleges/Legal",
        name: "Legal",
        component: Legal,
        meta: {
          // type: 4,
          title: "法律声明-浙江华为门户网站"
          // serial: 2
        }
      },
      {
        path: "/privacy/agreement",
        name: "PrivacyAgreement",
        component: PrivacyAgreement,
        meta: {
          // type: 4,
          title: "隐私协议-浙江华为门户网站"
          // serial: 2
        }
      },
      {
        path: "/privacy/PersonalData",
        name: "PrivacyPersonalData",
        component: PrivacyPersonalData,
        meta: {
          // type: 4,
          title: "个人数据维护-浙江华为门户网站"
          // serial: 2
        }
      },
      {
        path: "/colleges/Website",
        name: "Website",
        component: Website,
        meta: {
          type: 5,
          title: "网站地图-浙江华为门户网站",
          serial: 6
        }
      },
      {
        path: "/home/aboutus",
        name: "aboutus",
        component: AboutUs,
        meta: {
          type: 1,
          title: "关于我们-浙江华为门户网站",
          serial: 1
        }
      },
      {
        path: "/home/feedback",
        name: "feedback",
        component: Feedback,
        meta: {
          type: 1,
          title: "需求反馈-浙江华为门户网站",
          serial: 0
        }
      },
      {
        path: "/home/news",
        name: "Content",
        component: NewsIndex,
        meta: {
          type: 1,
          title: "新闻中心-浙江华为门户网站",
          serial: 2
        },
        redirect: "/home/news/page",
        children: [
          {
            path: "/home/news/page",
            name: "NewsIndex",
            component: SubjectAndNewsCenter,
            meta: {
              type: 1,
              title: "新闻中心-浙江华为门户网站",
              serial: 2
            }
          },
          {
            path: "/home/news/more",
            name: "NewsMore",
            component: NewsCenter,
            meta: {
              type: 1,
              title: "更多新闻-浙江华为门户网站",
              serial: 2
            }
          },
          {
            path: "/home/news/det/:aid",
            name: "NewsDetailed",
            component: NewsDetail,
            meta: {
              type: 1,
              title: "新闻详情-浙江华为门户网站",
              serial: 2
            }
          },
          {
            path: "/home/reports/more",
            name: "ReportsMore",
            component: ReportsCenter,
            meta: {
              type: 1,
              title: "更多新闻-浙江华为门户网站",
              serial: 2
            }
          },
        ]
      },
      {
        path: "/home/pub/bidding",
        name: "PubBidding",
        component: PubBiddingIndex,
        meta: {
          type: 5,
          title: "招标公告-浙江华为门户网站",
          serial: 5
        },
        redirect: "/home/pub/bidding/page",
        children: [
          {
            path: "/home/pub/bidding/page",
            name: "pubBiddingIndex",
            component: SubjectAndPubBiddingCenter,
            meta: {
              type: 5,
              title: "招标公告-浙江华为门户网站",
              serial: 5
            }
          },
          {
            path: "/home/pub/bidding/more",
            name: "pubBiddingMore",
            component: PubBiddingCenter,
            meta: {
              type: 5,
              title: "招标公告-浙江华为门户网站",
              serial: 5
            }
          },
          {
            path: "/home/pub/bidding/:aid",
            name: "pubBiddingDetail",
            component: PubBiddingDetail,
            meta: {
              type: 5,
              title: "招标公告-浙江华为门户网站",
              serial: 5
            }
          },
          {
            path: "/home/pub/bidding/:aid/submit",
            name: "pubBiddingApplySubmit",
            component: PubBiddingApplySubmit,
            meta: {
              type: 5,
              title: "招标公告-浙江华为门户网站",
              serial: 5
            }
          },
          {
            path: "/home/pub/bidding/:aid/download",
            name: "pubBiddingFileDownload",
            component: PubBiddingFileDownload,
            meta: {
              type: 5,
              title: "招标公告-浙江华为门户网站",
              serial: 5
            }
          }
        ]
      },
      {
        path: "/home/report/det/:aid",
        name: "report",
        component: Report,
        meta: {
          type: 1,
          title: "专题报道-浙江华为门户网站",
          serial: 1
        }
      },
      {
        path: "/new/arrival/:id",
        name: "new-arrival",
        component: NewArrival,
        meta: {
          type: 1,
          title: "浙江华为门户网站",
          serial: 1
        }
      },
      
      ...searchRoute
      // ...personalRoute,
      // ...certificaRoute,
      // ...courseRoute,
      // ...articleRoute,
      // // ...settingRoute,
      // ...personalSettingRouter
    ]
  },
  //政企模块
  EnterpriseRoute,
  PartnerRoute,
  CollegesRoute,
  RecruitRoute
  // 学习页
  // {
  //   path: "/course-detail",
  //   name: "courseDetail",
  //   component: () =>
  //     import("@/zh-website/src/views/course/course-detail/Index.vue")
  // },

  // {
  //   // 找回密码
  //   path: "/get-password",
  //   name: "getPassword",
  //   meta: {
  //     noAuth: true
  //   },
  //   component: () => import("@/zh-website/src/views/get-password/Index.vue")
  // },
  // {
  //   // 重置密码
  //   path: "/reset-password",
  //   name: "resetPassword",
  //   meta: {
  //     noAuth: true
  //   },
  //   component: () => import("@/zh-website/src/views/get-password/Index.vue")
  // },
  // {
  //   // 发送邮箱重置密码
  //   path: "/get-password-email",
  //   name: "getPasswordEmail",
  //   meta: {
  //     noAuth: true
  //   },
  //   component: () => import("@/zh-website/src/views/get-password/Index.vue")
  // },
  // {
  //   path: "/help",
  //   name: "help",
  //   meta: {
  //     noAuth: true
  //   },
  //   component: () =>
  //     import("@/zh-website/src/views/service-agreement/index.vue")
  // }
];

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes
});

router.onError(error => {
  const chunkErr = "ChunkLoadError: Loading chunk";
  if (error.toString().indexOf(chunkErr) > -1) {
    location.reload();
  }
});

export default router;
